module.exports = __webpack_public_path__ + "img/4.10af22bf.jpg";